import { useEffect } from "react";
import styled from "styled-components";

const Modal = ({ title, content, isOpen, onClose, onConfirm, closeButtonName }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    // 컴포넌트가 언마운트되거나 모달이 닫힐 때 스크롤을 다시 허용
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);
  const EnterContent = () => {
    return content
      .split("<br/>")
      .map((line, index) => <div key={index}>{line}</div>);
  };
  return (
    <>
      {isOpen && (
        <Back onClick={onClose}>
          <Box>
            <h2>{title}</h2>
            <Content>{EnterContent()}</Content>
            <Buttons>
              <Button onClick={onClose}>{onConfirm ? "취소" : "확인"}</Button>
              {onConfirm && <Button onClick={onConfirm}>{closeButtonName || "확인"}</Button>}
            </Buttons>
          </Box>
        </Back>
      )}
    </>
  );
};

export default Modal;

const Back = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const Box = styled.div`
  background-color: white;
  width: 420px;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation-name: fadeInUp;
  animation-duration: 1s;

  h2 {
    margin-bottom: 0px;
  }
`;

const Content = styled.div`
  margin: 20px 0 40px 0;
  white-space: pre-wrap;
  text-align: center;
  line-height: 140%;
`;
const Buttons = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  height: 50px;
  padding: 0 47px;
  background-color:#007912;
  color: white;
  border: none;
  border-radius: 52px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: 0.3s;
`;
